<template>
  <div v-loading="listContentLoading">
    <el-button
      v-if="showBack"
      style="padding: 0; margin: 20px;"
      type="text"
      icon="el-icon-back"
      @click="$router.go(-1)"
    >
      返回
    </el-button>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.name"
      clearable
      placeholder="请输入名称"
    ></el-input>
    <el-select
        v-if="!showBack"
        class="search-el"
        size="mini"
        v-model="query.channel_id"
        placeholder="请选择渠道"
        clearable
        filterable
    >
      <el-option label="全部渠道" value="-1"></el-option>
      <el-option
          v-for="item in channelList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      >
      </el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getChannelItemList()">
      查询</el-button
    >
    <el-button type="primary" size="mini" @click="toCreate()">
      新建推广位</el-button
    >

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column label="推广位名称" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="toCreate(row.id, row.name)"
            >
              <div>{{ row.name }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="code"
          label="推广码"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="所属渠道" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ filterChannel(row.channel_id) }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="uv"
          label="30天点击uv"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="pv"
          label="30天点击pv"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="paid_order_num"
          label="30天付款笔数"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="paid_amount"
          label="30天付款收入"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <!-- <el-button
              type="danger"
              size="mini"
              @click="deleteChannelItem(row.id)"
            >
              删除
            </el-button> -->

            <el-button size="mini" @click="toChannelItemData(row.channel_id, row.id)">
              数据
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getChannelItemList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getChannelList,
  getChannelItemList,
  createUpdateChannelItem,
  deleteChannelItem,
} from "@/api/cChannel";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        channel_id: '',
        name: "",
      },
      channelList: [],
      channelList1: [],
      showBack: false,

      listContentLoading: false,
    };
  },
  created: function () {
    if (this.$route.query.channel_id != undefined) {
      this.query.channel_id = Number(this.$route.query.channel_id);
      this.showBack = true;
    }
    
    this.getChannelItemList();
    getChannelList({ only_name: 1 }).then((response) => {
      this.channelList = response.data;
      response.data.forEach((item) => {
        this.channelList1[(item.id).toString()] = item.name;
      });
    });
  },
  methods: {
    toChannelItemData(channel_id, channel_item_id) {
        this.$router.push({
            path: "/channel/itemData",
            query: {
                channel_id: channel_id,
                channel_item_id: channel_item_id
            },
        });
      },

    filterChannel(channel_id) {      
      return this.channelList1[channel_id.toString()];
    },
    toCreate(id = 0, name = "") {
      var channel_id = 0;
      if (this.$route.query.channel_id != undefined) {
        channel_id = this.$route.query.channel_id;
      } else {
        channel_id = this.query.channel_id;
      }
      if (id == 0 && Number(channel_id) <= 0) {
        this.$message({
          showClose: true,
          message: '请先选择渠道',
          type: 'error'
        });
        return;
      }
      this.$prompt("请输入推广位名称", "推广位", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: name,
      }).then(({ value }) => {
        createUpdateChannelItem({
          channel_id: channel_id,
          id: id,
          name: value,
        }).then((response) => {
          if (response.code == 1) {
            this.$message.success(response.message);
            this.getChannelItemList();
          }
        });
      });
    },

    getChannelItemList() {
      this.loading = true;
      getChannelItemList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    deleteChannelItem(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteChannelItem({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getChannelItemList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {
    
  },
};
</script>
